import { Center, Loader, Stack, Text } from '@mantine/core';
import { type ReactNode } from 'react';

interface AuthPendingScreenProps {
  checkingRole?: boolean;
}

/** Estado explícito y legible mientras Firebase resuelve sesión o permisos. */
export function AuthPendingScreen({
  checkingRole = false,
}: AuthPendingScreenProps): ReactNode {
  const message = checkingRole
    ? 'Comprobando permisos de administración…'
    : 'Cargando sesión…';

  return (
    <Center
      h="100vh"
      role="status"
      aria-live="polite"
      aria-busy="true"
      data-agent-id={
        checkingRole ? 'admin.auth.checking-role' : 'admin.auth.loading'
      }
    >
      <Stack align="center" gap="sm">
        <Loader aria-hidden="true" />
        <Text c="dimmed">{message}</Text>
      </Stack>
    </Center>
  );
}
